import React from 'react'
import {connect} from 'react-redux'
import {Avatar, Button, Card, Checkbox, Col, Form, Image, Input, message, Modal, Row} from 'antd'
import {withRouter} from 'react-router'
import Cookies from 'universal-cookie'
import axios from 'axios'

import {COOKIE_MAX_AGE, COOKIE_TOKEN} from '../app/constant'
import {userLogin} from '../action/user'
import {artistSave} from '../action/artist'
import {login, resetPwd} from '../api/user'
import {getArtist} from '../api/artists'
import {getArtistNames, getArtistNamesOnly} from '../api/artistNames'
import logoRoundSmall from '../asset/image/Logo_round-small.png'
import Title from 'antd/es/typography/Title'
import {URL_PIECES, URL_SIGNUP} from '../const'
import {is_admin_user} from "../app/role";
import withBreakpoint from "../app/withBreakpoint";

@connect(null, {
    userLogin, //passes the info to the store (?)
    artistSave
})
class Login extends React.Component {
    constructor(props) {
        super(props)
        this.formRef = React.createRef()

        this.state = {
            visible: false,
            loginLoading: false,
            confirmLoading: false,
            modelText: '',
            username: '',
            breakpoint: this.props.breakpoint
        }

        this.inviteCode = ''
        this.redirectPath = URL_PIECES
        this.searchPath = this.props.location?.search || ""

        if (this.searchPath) {
            try {
                const keys = this.searchPath.split("&")
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i]
                    if (key.startsWith("?invite_code=")) {
                        this.inviteCode = key.replace("?invite_code=", "")
                    } else if (key.startsWith("?redirect=")) {
                        this.redirectPath = key.replace("?redirect=", "")
                    }
                }
            } catch (e) {

            }
        }

        const artistCards = [
            {
                text: 'RevArt provides me with excellent opportunities and marketing assistance in the\n' +
                    '                                    notoriously complex art world.\n' +
                    '                                    I can focus on creating while they work on my behalf to get my work in front of\n' +
                    '                                    prospective brands and clients.',
                avatar: 'https://revart.co/sam/about/Bernie_Photo_small_copy.png',
                name: 'Bernie McCabe',
                title: '- Pop Art Artist'
            },
            {
                text: 'I was introduced to RevArt in 2020, and I was immediately impressed by the enthusiasm and professionalism of the founders.',
                avatar: 'https://revart.co/sam/about/Usha09a.jpg',
                name: 'Usha Shukla',
                title: '- Painter'
            },
            {
                text: 'I decided to collaborate with RevArt because I was struck by their mission. To want to democratize ' +
                    'the art world but also ensure artists are supported and fairly compensated for their work is a very ' +
                    'ambitious and challenging goal.\n',
                avatar: 'https://revart.co/sam/about/Artist_Headshot_1.JPG',
                name: 'Alexandra Chiou',
                title: '- Visual Artist'
            }
        ]

        function getRandomInt(max) {
            return Math.floor(Math.random() * max);
        }

        this.artistCard = artistCards[getRandomInt(artistCards.length)]
    }

    onFinish = (values) => {
        const getArtistNameStr = (name_obj) => {
            if (name_obj.nick_name) {
                return name_obj.nick_name
            }
            let name = ''
            if (name_obj.first_name) {
                name = name_obj.first_name + ' '
            }
            if (name_obj.middle_name) {
                name += name_obj.middle_name + ' '
            }
            if (name_obj.last_name) {
                name += name_obj.last_name
            }
            return name.trim()
        }

        const loginSuccess = async (response) => {
            const artistId = response.data.role === 'artist' ? (await getArtist(response.data.user_id)).data.id : null
            this.props.userLogin({
                id: response.data.user_id,
                token: response.data.token,
                email: values.username,
                artistId: artistId,
                userId: is_admin_user(response.data.role) ? null : response.data.user_id,
                role: response.data.role,
                artistName: response.data.role === 'artist' ? getArtistNameStr((await getArtistNames(artistId)).data) : null,
                action: 'login'
            })
            axios.defaults.headers.common['Authorization'] = 'Token ' + response.data.token
            if (is_admin_user(response.data.role)) {
                const data = (await getArtistNamesOnly()).data.results
                this.props.artistSave(data)
            }

            const cookies = new Cookies()
            const option = {path: '/'}
            option.maxAge = COOKIE_MAX_AGE
            cookies.set(COOKIE_TOKEN, response.data.token, option)
        }

        const loginFailed = (error) => {
            if (error.message === 'Request failed with status code 400') {
                message.error('Invalid username/password. Remember to use email for your username.').then((r) => {
                })
            } else {
                message.error('Network error').then(() => {
                })
            }
        }

        this.setState({
            loginLoading: true
        })
        const usernameStr = values.username.toString()
        const usernameLow = usernameStr.charAt(0).toLowerCase() + usernameStr.slice(1)
        login(usernameLow, values.password)
            .then(async (response) => {
                await loginSuccess(response)
                this.setState({
                    loginLoading: false
                })
                if (this.redirectPath.startsWith("https://")) {
                    window.location.href = this.redirectPath
                } else {
                    let inviteCodeSuffix = this.inviteCode ? "?invite_code=" + this.inviteCode : ''
                    this.props.history.push({pathname: this.redirectPath + inviteCodeSuffix})
                }
            })
            .catch((error) => {
                const usernameCap = usernameStr.charAt(0).toUpperCase() + usernameStr.slice(1)
                login(usernameCap, values.password).then(async (response) => {
                    await loginSuccess(response)
                    this.setState({
                        loginLoading: false
                    })
                    if (this.redirectPath.startsWith("https://")) {
                        window.location.href = this.redirectPath
                    } else {
                        let inviteCodeSuffix = this.inviteCode ? "?invite_code=" + this.inviteCode : ''
                        this.props.history.push({pathname: this.redirectPath + inviteCodeSuffix})
                    }
                }).catch((error) => {
                    this.setState({
                        loginLoading: false
                    })
                    loginFailed(error)
                })
            })
    }

    showResetPassword = () => {
        this.setState({visible: true})
    }

    handleOk = () => {
        this.setState({
            confirmLoading: true
        })

        if (this.state.username !== undefined && this.state.username !== '') {
            resetPwd(this.state.username)
                .then((response) => {
                    message.success('A Reset email has been sent to ' + this.state.username).then((r) => {
                    })
                    this.setState({visible: false, confirmLoading: false})
                })
                .catch((error) => {
                    message.error(error.message).then((r) => {
                    })
                    this.setState({visible: false, confirmLoading: false})
                })
        } else {
            message.error('Need to specify the user email first!').then((r) => {
            })
            this.setState({visible: false, confirmLoading: false})
        }
    }

    handleCancel = () => {
        this.setState({visible: false})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.breakpoint) {
            this.setState({breakpoint: nextProps.breakpoint})
        }
    }

    render() {

        let paddingStr = '1%'
        let paddingTop = '12%'
        let cardWidth = '80%'

        if (this.state.breakpoint?.xs) {
            paddingStr = '0%';
            paddingTop = '6%';
            cardWidth = '98%';
        }
        if (this.state.breakpoint?.sm) paddingStr = '3%'
        if (this.state.breakpoint?.md) paddingStr = '8%'
        if (this.state.breakpoint?.lg) paddingStr = '16%'
        if (this.state.breakpoint?.xl) paddingStr = '16%'
        if (this.state.breakpoint?.xxl) paddingStr = '24%'


        return (
            <div
                style={{
                    height: '100vh',
                    overflowY: 'auto',
                }}
            >
                <Row style={{flexDirection: 'row', height: '100%', width: '100%'}}>

                    <Col xs={24} sm={24} md={24} lg={12}>
                        <Card style={{
                            paddingLeft: paddingStr, paddingRight: paddingStr, paddingTop: paddingTop, height: '100%',
                            width: '100%'
                        }}>
                            <Row justify='space-around' align='middle'>
                                <Col span={4}>
                                    <Image src={logoRoundSmall} preview={false} height='84px' width='84px'/>
                                </Col>
                                <Col span={12}>
                                    <Title style={{paddingLeft: 12, paddingRight: 24, paddingTop: 24}} level={1}>
                                        SMART Login
                                    </Title>
                                </Col>
                            </Row>
                            <Form
                                ref={this.formRef}
                                layout={'vertical'}
                                name='normal_login'
                                style={{backgroundColor: '#ffffff', marginTop: 18, padding: 24}}
                                initialValues={{
                                    remember: true
                                }}
                                onFinish={this.onFinish}
                                onValuesChange={(changed, allFields) => {
                                    this.setState(changed)
                                }}
                            >
                                <Form.Item
                                    name='username'
                                    label={<span style={{fontSize: '16px'}}>Email</span>}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your Email!'
                                        }
                                    ]}
                                >
                                    <Input/>
                                </Form.Item>
                                <Form.Item
                                    name='password'
                                    label={<span style={{fontSize: '16px'}}>Password</span>}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your Password!'
                                        }
                                    ]}
                                >
                                    <Input type='password'/>
                                </Form.Item>
                                <Form.Item>
                                    <Form.Item name='remember' valuePropName='checked' noStyle>
                                        <Checkbox>Remember me</Checkbox>
                                    </Form.Item>

                                    <a style={{float: 'right'}} onClick={this.showResetPassword}>
                                        Forgot password
                                    </a>
                                    <Modal
                                        title='Send password reset email to'
                                        visible={this.state.visible}
                                        onOk={this.handleOk}
                                        confirmLoading={this.state.confirmLoading}
                                        onCancel={this.handleCancel}
                                    >
                                        <p>{this.state.username}</p>
                                    </Modal>
                                </Form.Item>

                                <Form.Item>
                                    <Button
                                        size={'large'}
                                        type='primary'
                                        loading={this.state.loginLoading}
                                        htmlType='submit'
                                        disabled={!(this.state.username && this.state.password)}
                                        style={{
                                            width: '100%',
                                            backgroundColor: '#050a30',
                                            fontWeight: 700,
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <span style={{cursor: 'pointer'}}>Sign in to your account</span>
                                    </Button>
                                    <p style={{fontSize: 16, textAlign: 'center', fontWeight: 700}}>
                                        Doesn&apos;t have an account? <a href={URL_SIGNUP + this.searchPath}>Sign up</a>
                                    </p>
                                </Form.Item>
                            </Form>
                            <Col xs={24} sm={24} md={24} lg={0}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '100%'
                                }}>
                                    <Card style={{
                                        maxWidth: 540,
                                        width: cardWidth,
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        padding: 16
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                             className="nextui-c-PJLV">
                                            <path
                                                d="M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.945-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 6.5 10zm11 0c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 17.5 10z"
                                                className="nextui-c-PJLV nextui-c-PJLV-icQelhk-css"/>
                                        </svg>
                                        <p>{this.artistCard.text}</p>
                                        <Avatar size={50}
                                                src={this.artistCard.avatar}/>
                                        <span style={{
                                            fontWeight: 'bold',
                                            fontSize: 18,
                                            marginLeft: 12
                                        }}>{this.artistCard.name}</span>
                                        <p style={{
                                            fontSize: 16,
                                            color: 'grey',
                                            marginTop: 12
                                        }}>{this.artistCard.title}</p>

                                    </Card>
                                </div>
                            </Col>

                            <a href={'https://revart.co/'}>
                                <span style={{
                                    color: '#050a30',
                                    position: 'absolute',
                                    left: 20,
                                    bottom: 10
                                }}>© RevArt</span>
                            </a>
                            <a href={'https://revart.co/privacy/'}>
                                <span style={{
                                    color: '#050a30',
                                    position: 'absolute',
                                    bottom: 10,
                                    left: 120
                                }}>© Privacy</span>
                            </a>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={12}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%'
                        }}>
                            <Card style={{
                                maxWidth: 540,
                                width: '80%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                padding: 16
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                     className="nextui-c-PJLV">
                                    <path
                                        d="M6.5 10c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.318.142-.686.238-1.028.466-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.945-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 6.5 10zm11 0c-.223 0-.437.034-.65.065.069-.232.14-.468.254-.68.114-.308.292-.575.469-.844.148-.291.409-.488.601-.737.201-.242.475-.403.692-.604.213-.21.492-.315.714-.463.232-.133.434-.28.65-.35l.539-.222.474-.197-.485-1.938-.597.144c-.191.048-.424.104-.689.171-.271.05-.56.187-.882.312-.317.143-.686.238-1.028.467-.344.218-.741.4-1.091.692-.339.301-.748.562-1.05.944-.33.358-.656.734-.909 1.162-.293.408-.492.856-.702 1.299-.19.443-.343.896-.468 1.336-.237.882-.343 1.72-.384 2.437-.034.718-.014 1.315.028 1.747.015.204.043.402.063.539l.025.168.026-.006A4.5 4.5 0 1 0 17.5 10z"
                                        className="nextui-c-PJLV nextui-c-PJLV-icQelhk-css"/>
                                </svg>
                                <p>{this.artistCard.text}</p>
                                <Avatar size={50}
                                        src={this.artistCard.avatar}/>
                                <span style={{
                                    fontWeight: 'bold',
                                    fontSize: 18,
                                    marginLeft: 12
                                }}>{this.artistCard.name}</span>
                                <p style={{fontSize: 16, color: 'grey', marginTop: 12}}>{this.artistCard.title}</p>

                            </Card>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default withBreakpoint(withRouter(Login))
